import(/* webpackMode: "eager", webpackExports: ["AppDetailsHeader"] */ "/app/src/components/display-page/app-details-header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ArchitecturePage"] */ "/app/src/components/display-page/architecture/architecture-page.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["InsightsPage"] */ "/app/src/components/display-page/insights/insights-page.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PromptsPage"] */ "/app/src/components/display-page/prompts/prompts-page.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SessionDetails"] */ "/app/src/components/display-page/session-details.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["KahuInvocationPoint"] */ "/app/src/components/kahu-ai/kahu-invocation-point.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeProvider"] */ "/app/src/components/theme-provider/theme-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ApplicationsProvider"] */ "/app/src/providers/ApplicationsProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AppUserProvider"] */ "/app/src/providers/AppUserProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/providers/AuthProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["KahuProvider"] */ "/app/src/providers/KahuProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LanguageProvider"] */ "/app/src/providers/LanguageProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/providers/ToggleProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/providers/TourGuideProvider.tsx");
